import attListPopupView from './attListPopupComponent.html';
import './attListPopupComponent.css';
import { ensure } from 'components/sharpr/ensure/ensure.js';
import _ from 'lodash';

export function attListPopupComponent() {
	return {
		bindings: {
			titleText: '<',
			attachments: '<',
			startIndex: '<?',
			searchTerm: '<?',
			onClose: '&',
		},
		controllerAs: 'vm',
		controller: attListPopupComponentCtrl,
		template: attListPopupView,
	};
}

export class attListPopupComponentCtrl {
	constructor(modal, Att, EventTracker) {
		'ngInject';
		this.modal = modal;
		this.Att = Att;
		this.EventTracker = EventTracker;
	}

	$onInit() {
		if (this.attachments.length == 0) {
			return false;
		}
		this.attachments.forEach(att => {
			att.escapedUrl = _.escape(att.url);
			// set att.viewer to 'none' if window is smaller than 768 width
			att.viewer = document.documentElement.clientWidth < 768 ? 'none' : this.Att.getViewerType(att);
		});
		this.showAttList = false;
		this.currentAttIdx = 0;
		this.attachment = this.attachments[0];
		this.attCount = this.attachments.length;
		this.changeNames();
		if (this.startIndex && this.startIndex > 0) {
			this.jumpToAtt(this.startIndex);
		} else {
			this.trackView();
		}
	}

	/**
	 * Move to the next or previous attachment
	 * @param {String} rightOrLeft  'right' to show the next attachment in the
	 *								array; 'left' to show the previous.
	 */
	nav(rightOrLeft) {
		if (rightOrLeft == 'right') {
			this.currentAttIdx++;
		} else {
			this.currentAttIdx = this.currentAttIdx == 0 ? this.attachments.length - 1 : this.currentAttIdx - 1;
		}
		this.currentAttIdx = this.currentAttIdx % this.attCount;
		this.attachment = this.attachments[this.currentAttIdx];
		this.changeNames();
	}

	/**
	 * Display a specific attachment by its index in `this.attachments`
	 * @param {Int} idx  The index of the attachment to be shown
	 */
	jumpToAtt(idx) {
		this.attachment = this.attachments[idx];
		this.currentAttIdx = idx;
		this.changeNames();
		this.trackView();
	}

	/**
	 * Track that this document was previewed
	 */
	trackView() {
		this.EventTracker.save('preview_document', {
			viewer_type: this.attachment.viewer,
			attachment_id: this.attachment.id,
			search_term: ensure
				.array(this.searchTerm)
				.map(t => t.word)
				.join(' '),
			list_index: this.currentAttIdx + 1,
			list_total: this.attachments.length,
		});
	}

	/**
	 * The component shows the names of the next and previous attachments along
	 * side the nav buttons. This calculates the name of the next and previous
	 * attachments based on `this.currentAttIdx`.
	 */
	changeNames() {
		var prevIdx = this.currentAttIdx == 0 ? this.attachments.length - 1 : this.currentAttIdx - 1;
		var nextIdx = this.currentAttIdx + 1;
		this.prevName = this.attachments[prevIdx % this.attCount].filename;
		this.nextName = this.attachments[nextIdx % this.attCount].filename;
	}

	directLink() {
		let alert = `
			<input type="text" class="form-input full-width" value="${this.attachment.escapedUrl}">
			<br><br>
			<strong>Note:</strong> Users must log in before downloading this file.
		`;
		let options = { escapedHtml: alert, heading: `Direct Link to ${this.attachment.filename}` };
		this.modal.text(options).focus();
	}
}
